import { NotificationScreen } from '@tassat/layout';
import React from 'react';

import { useClientLogos } from 'SharedComponents/hooks/useClientLogos';
import { useClientThemeData } from 'SharedComponents/hooks/useClientThemeData';

import { muiStyles } from './styles';

const MaintenancePage = () => {
    const classes = muiStyles();
    const clientInfo = useClientThemeData();
    const clientLogos = useClientLogos();

    const maintenanceProps = {
        clientLogoUrl: clientLogos.ApplicationLogoUrl,
        headerLogoHeight: 65,
        messages: [
            'The site is undergoing scheduled maintenance.',
            'Please contact us for assistance at any time, 24 hours a day, 7 days a week.'
        ],
        subtitle: 'Your Gateway to the Future of Digital Financial Services',
        supportEmail: clientInfo.support.contactInfo.email || '#',
        supportPhone: clientInfo.support.contactInfo.phoneDirect || clientInfo.support.contactInfo.phoneTollFree,
        title: 'Maintenance'
    };

    return (
        <div className={classes.container}>
            <NotificationScreen
                {...maintenanceProps}
                type='prop'
            />
        </div>
    );
};

export default MaintenancePage;